// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".line-chart .apexcharts-inner{-webkit-transform:translateY(35px);transform:translateY(35px)}.line-chart .apexcharts-xaxis-tick{display:none}.line-chart .apexcharts-legend-series{display:-webkit-box!important;display:-ms-flexbox!important;display:flex!important}.line-chart .apexcharts-legend-marker{margin-right:5px}", ""]);
// Exports
module.exports = exports;
